import { Box, Input, MenuItem, Select } from "@mui/material";
import React from "react";
import { useStyles } from "../styles";

const CourseInfo = ({
  courseListSelector,
  handleChangeCourseInfo,
  courseInfo,
  groupScore
}) => {
  const classes = useStyles();

  return (
    <Box sx={{ marginRight: "0 !important" }}>
      <Select
        variant="standard"
        disableUnderline
        fullWidth
        value={courseInfo.name}
        disabled={
          groupScore.group1.filter((el) => el.score != "").length >=
            1 ||
          groupScore.group2.filter((el) => el.score != "").length >= 1
        }
        sx={{
          maxWidth: "180px",
          width: "180px",
          "::before": { display: "none" },
        }}
        className={classes.selectBox}
        onChange={(e) => handleChangeCourseInfo(e.target.value, "name")}
      >
        <MenuItem selected value="Course Name" disabled>
          Course Name
        </MenuItem>
        {!courseListSelector?.loading &&
          courseListSelector?.data &&
          courseListSelector?.data.length > 0 &&
          courseListSelector.data.map(({ _id, name }) => {
            return (
              <MenuItem key={_id} value={_id}>
                {name}
              </MenuItem>
            );
          })}
      </Select>

      <Input
        fullWidth
        type="date"
        value={courseInfo.date}
        className={classes.selectBox}
        sx={{ "::before": { display: "none" } }}
        onChange={(e) => handleChangeCourseInfo(e.target.value, "date")}
      />

      <Input
        fullWidth
        type="time"
        value={courseInfo.time}
        className={classes.selectBox}
        sx={{ "::before": { display: "none" } }}
        onChange={(e) => handleChangeCourseInfo(e.target.value, "time")}
      />
    </Box>
  );
};

export default CourseInfo;
